// Angular Files
import { Component, Inject, TemplateRef } from '@angular/core';

// Angular Material Files
import { MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';

// Full-screen M3 dialog used on the public-portal mobile breakpoint. Enter/exit motion is left
// to MatDialog's built-in animation; only the sizing + chrome is customised here.
//
// Width is % rather than vw: the overlay pane is position: fixed, and on desktop browsers with
// classic (non-overlay) scrollbars, 100vw resolves against the viewport including the scrollbar
// gutter — wider than the visible window whenever the page behind the dialog has a vertical
// scrollbar — which forced a spurious horizontal scrollbar on the dialog itself. % doesn't
// include that gutter.
export const FULL_PAGE_DIALOG_CONFIG: MatDialogConfig = {
    panelClass: 'dialog--full-page',
    width: '100vw',
    height: '100dvh',
    maxWidth: '100vw',
    maxHeight: '100dvh',
};

@Component({
    selector: 'app-full-page-dialog-container',
    templateUrl: './full-page-dialog-container.component.html',
    styleUrls: ['./full-page-dialog-container.component.scss'],
    standalone: false
})
export class FullPageDialogContainerComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { template: TemplateRef<unknown> }
    ) { }
}
